import React from 'react';
import {Field, reduxForm} from 'redux-form';
import i18n from "i18next";
import RaisedButton from 'material-ui/RaisedButton';
import styles from '../../../styles/styles'
import {renderPasswordField, renderTextField} from "../../../services/form";
import withTranslation from "../../../hoc/withTranslation";

const validate = values => {
    const errors = {};
    const requiredFields = [
        'email',
        'username'
    ];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = i18n.t('generic.error_invalid_email');
    }

    if ((values.password || values.repeat) && values.password !== values.repeat) {
        errors.password = i18n.t('generic.error_password_should_be_identical');
        errors.repeat = errors.password;
    }

    return errors;
};

const AdminForm = (props) => {
    const {handleSubmit, pristine, reset, submitting} = props;

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <Field id="id" name="id" component={renderTextField}
                       label={props.t('generic.identifier')} fullWidth={true} readOnly={true} />
                <Field id="email" name="email" component={renderTextField}
                       label={props.t('user.email')} fullWidth={true} />
                <Field id="username" name="username" component={renderTextField}
                       label={props.t('user.username')} fullWidth={true} />
                <Field id="firstname" name="firstname" component={renderTextField}
                       label={props.t('user.firstname')} fullWidth={true} />
                <Field id="lastname" name="lastname" component={renderTextField}
                       label={props.t('user.lastname')} fullWidth={true} />
                <Field id="password" name="password" component={renderPasswordField}
                       label={props.t('account_page.password_optional')} fullWidth={true} />
                <Field id="repeat" name="repeat" component={renderPasswordField}
                       label={props.t('account_page.repeat_password_optional')} fullWidth={true} />
            </div>
            <div style={styles.formButtons}>
                <RaisedButton
                    style={styles.formButton}
                    label={props.t('generic.save')}
                    disabled={pristine || submitting}
                    type="submit"
                    primary={true}
                />

                <RaisedButton
                    style={styles.formButton}
                    label={props.t('generic.reset')}
                    type="button"
                    disabled={pristine || submitting}
                    onClick={reset}
                />
            </div>
        </form>
    );
};

export default reduxForm({
    form: 'editAdmin',
    validate
})(withTranslation(AdminForm));



// WEBPACK FOOTER //
// src/components/admin/AdminForm/AdminForm.js